import React, { useState } from 'react';
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";

const PasswordInput = ({ value, onChange, placeholder }) => {

    const [isShowPassword, setisShowPassword] = useState(false);

    const toggleshowpassword = () => {
        setisShowPassword(!isShowPassword)

    }
    return (
        <div className='flex items-center bg-transparent' >
            <input class="bg-gray-50 border border-gray-300 text-black rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full mr-3 p-2.5"
                required=""
                value={value}
                onChange={onChange}
                type={isShowPassword ? 'text' : 'password'}
                placeholder={placeholder || 'Password'}
            />
            {isShowPassword ?
                <FaRegEye
                    size={22}
                    className='text-primary cursor-pointer'
                    onClick={() => toggleshowpassword()}
                />
                :
                <FaRegEyeSlash size={22}
                    className='text-primary cursor-pointer'
                    onClick={() => toggleshowpassword()} />
            }
        </div>
    )
}

export default PasswordInput
